<kiene-kiene-table [tableDescriptor]="tableDescriptor"></kiene-kiene-table>

<input
    #invoiceKiFileInput
    type="file"
    hidden
    multiple
    accept="application/pdf,application/xml,text/xml,.pdf,.xml"
    (change)="onInvoiceKiFileSelected($event)"
/>
